import React, { Fragment, useContext, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Grid,
  Paper,
  Avatar,
  Typography,
  Divider,
  TextField,
} from "@material-ui/core";
import DataUsageRoundedIcon from "@material-ui/icons/DataUsageRounded";
import CheckCircleRoundedIcon from "@material-ui/icons/CheckCircleRounded";
import WallpaperRoundedIcon from "@material-ui/icons/WallpaperRounded";

// Contexts
import OrderContext from "../../../../../../context/orders/v1/OrdersContext";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
    fontSize: "0.9rem",
  },
  rowBottom: {
    marginBottom: "0.5rem",
  },
  avatar: {
    width: theme.spacing(4),
    height: theme.spacing(4),
    color: "white",
  },
  title: {
    color: theme.palette.text.primary,
    fontWeight: "bold",
    marginTop: "0.3rem",
  },
  lineItemBox: {
    minHeight: "4.5rem",
  },
  image: {
    width: 50,
    border: "1px solid whitesmoke",
  },
  divider: {
    marginTop: "1rem",
    marginBottom: "1rem",
  },
}));

const RefundLineItems = ({ type, lineItems, getImage, products }) => {
  const classes = useStyles();

  const { modalValues, setValues } = useContext(OrderContext);

  const [qtyList, setQtyList] = useState({});

  const handleChange = (e) => {
    if (e.target.id === "quantity") {
      const increased = e.target.value > qtyList[e.target.name];

      setQtyList({ ...qtyList, [e.target.name]: e.target.value });

      // Update Refund Line Items' Quantity
      modalValues.items.map((each) => {
        if (each.line_item_id === parseInt(e.target.name)) {
          if (increased) {
            each.quantity = each.quantity + 1;
          } else {
            each.quantity = each.quantity - 1;
          }
        }
      });

      setValues(modalValues);
    }
  };

  useEffect(() => {
    let temp = {};

    lineItems.map((each) => {
      temp[each.id] = 0;
    });

    setQtyList(temp);
  }, []);

  return (
    lineItems.length > 0 && (
      <Grid container direction="column" justifyContent="flex-start">
        <Paper className={classes.paper}>
          {" "}
          {/* Title */}{" "}
          <Grid
            item
            xs={12}
            container
            direction="row"
            alignItems="center"
            justifyContent="flex-start"
            className={classes.rowBottom}
          >
            <Grid item>
              <Avatar
                className={classes.avatar}
                style={{
                  backgroundColor: type === "unfulfilled" ? "orange" : "green",
                }}
              >
                {" "}
                {type === "unfulfilled" ? (
                  <DataUsageRoundedIcon />
                ) : (
                  <CheckCircleRoundedIcon />
                )}{" "}
              </Avatar>{" "}
            </Grid>{" "}
            & ensp;{" "}
            <Grid item>
              <Typography variant="body1" className={classes.title}>
                {" "}
                {type === "unfulfilled" ? "Unfulfilled" : "Fulfilled"}{" "}
              </Typography>{" "}
            </Grid>{" "}
          </Grid>
          {/* Items */}{" "}
          {lineItems.map((item, index) => {
            const image =
              products[item.product_id] &&
              getImage(item.variant_id, products[item.product_id]);

            const max_qty =
              type === "unfulfilled"
                ? item.fulfillable_quantity
                : item.quantity;

            // const max_qty =
            //   type === "unfulfilled"
            //     ? item.fulfillable_quantity
            //     : item.fulfillable_quantity === 0
            //     ? item.quantity
            //     : item.fulfillable_quantity;

            const qty = qtyList[item.id];
            const per_price = item.price_set.presentment_money.amount;
            const total =
              qty == 0 ? per_price : parseFloat(per_price * qty).toFixed(2);

            return (
              <Fragment key={index}>
                <Grid
                  item
                  xs={12}
                  container
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                  className={classes.lineItemBox}
                >
                  <Grid
                    item
                    xs={2}
                    container
                    direction="column"
                    alignItems="center"
                    justifyContent="center"
                  >
                    {" "}
                    {image ? (
                      <img className={classes.image} src={image} />
                    ) : (
                      <WallpaperRoundedIcon fontSize="large" />
                    )}{" "}
                  </Grid>
                  <Grid
                    item
                    xs={5}
                    container
                    direction="column"
                    alignItems="flex-start"
                    justifyContent="center"
                    style={{
                      textAlign: "left",
                    }}
                  >
                    <Grid item> {item.title} </Grid>{" "}
                    <Grid item> {item.variant_title} </Grid>{" "}
                    <Grid item> {item.sku} </Grid>{" "}
                    <Grid item> $ {per_price} </Grid>{" "}
                  </Grid>
                  <Grid
                    item
                    xs={2}
                    container
                    direction="column"
                    alignItems="flex-end"
                    justifyContent="center"
                  >
                    <TextField
                      type="number"
                      variant="outlined"
                      size="small"
                      margin="dense"
                      id="quantity"
                      name={String(item.id)}
                      InputProps={{
                        inputProps: {
                          min: 0,
                          max: max_qty,
                        },
                      }}
                      value={qty ? qty : 0}
                      onChange={handleChange}
                    />{" "}
                  </Grid>
                  <Grid
                    item
                    xs={1}
                    container
                    direction="column"
                    alignItems="flex-start"
                  >
                    & ensp; / {max_qty}{" "}
                  </Grid>
                  <Grid
                    item
                    xs={2}
                    container
                    direction="column"
                    alignItems="center"
                    justifyContent="center"
                  >
                    $ {total}{" "}
                  </Grid>{" "}
                </Grid>
                {index + 1 !== lineItems.length && (
                  <Divider
                    className={classes.divider}
                    orientation="horizontal"
                  />
                )}{" "}
              </Fragment>
            );
          })}
          {type === "unfulfilled" ? (
            <Typography
              variant="body2"
              style={{
                marginTop: "2rem",
                textAlign: "left",
              }}
            >
              Refunded items will be removed from the order.{" "}
            </Typography>
          ) : (
            <Typography
              style={{
                marginTop: "0.5rem",
              }}
            >
              {" "}
            </Typography>
          )}{" "}
        </Paper>{" "}
      </Grid>
    )
  );
};

export default RefundLineItems;
